import {BlockType, Blocks} from '../blocks/Blocks'
import {Hero, HeroType} from '../layout/Hero'

import {Breadcrumbs} from '../layout/Breadcrumbs'
import {Layout} from '../layout/Layout'
import {Overview} from '../layout/Overview'
import {PageCardType} from '../layout/cards/PageCard'
import {PageData} from '../../types'
import React from 'react'
import {style} from '../../util/style'
import {wrap} from '@codeurs/front'

const styles = style('news')

type NewsType = {
	hero: HeroType
	news: Array<PageCardType>
	overview_title?: string
	card_linklabel?: string
	blocks?: Array<BlockType>
}

export const News: React.FC<PageData & NewsType> = wrap(Layout)(
	({...props}) => {
		const {
			parents,
			title,
			hero,
			news,
			overview_title,
			card_linklabel,
			blocks
		} = props
		return (
			<div className={styles()}>
				<Hero {...hero} title={(hero && hero.title) || title} />
				<Breadcrumbs parents={parents} title={title} />
				<Overview
					container={true}
					className={styles('overview')}
					title={overview_title}
					items={news.map((newsItem) => ({
						...newsItem,
						imageLabel:
							newsItem.date && Date.parse(newsItem.date)
								? new Date(newsItem.date).toLocaleDateString('nl-BE', {
										year: 'numeric',
										month: 'long',
										day: 'numeric'
								  })
								: undefined
					}))}
					card_linklabel={card_linklabel}
				/>
				<Blocks blocks={blocks} container={true} />
			</div>
		)
	}
)
